export default "__VITE_ASSET__83791e12__"